<template>
  <div
    id="login-page"
    class="login-page bg-cover bg-center bg-no-repeat"
    :class="loginParent"
  >
    <div class="login-header-section">
      <div v-if="logo">
        <img
          v-if="isHeaderImg"
          :srcset="`${signHeader}, ${signHeader2x}`"
          :src="signHeader"
          alt="Thrive"
        />
        <img
          v-if="isHeaderImg"
          class="signin-icon"
          :srcset="`${signInIcon}, ${signInIcon2x}`"
          :src="signInIcon"
          alt="Thrive"
        />
      </div>
      <SignUp
        v-if="$getState('loginOperation') === 'signUp'"
        :click-handler="() => backToLoginPage()"
      >
      </SignUp>
      <SignIn
        v-else-if="$getState('loginOperation') === 'signIn'"
        :click-handler="() => $setState('loginOperation', null)"
      >
      </SignIn>

      <div v-else class="flex flex-col h-screen login-page__chooser">
        <div class="text-center flex-grow flex justify-center items-center">
          <div class="table">
            <img
              v-if="corporationLogo"
              class="login-page__logo"
              :srcset="corporationSrcSet"
              :src="`${$getState('corporation')['white_logo']}`"
              alt="Thrive"
            />

            <img
              v-else
              class="login-page__logo"
              :srcset="loginLogoSrcSet"
              :src="loginLogo2x"
              alt="Thrive"
            />
          </div>
        </div>
        <p
          class="tracking-normal landing-page-text text-12 text-text opacity-60 mb-4em"
        >
          {{ $t("Login page para") }}
        </p>

        <Button
          type="button"
          classes="mb-20 btn-active btn-full signup-btn"
          :text="$t('Sign Up')"
          v-if="$getState('showSignUpSlider')"
          :click-handler="() => operationHandler('intro')"
        ></Button>

        <Button
          classes="mb-20 btn-full btn-active"
          type="button"
          v-if="!$getState('showSignUpSlider')"
          :text="$t('Sign Up')"
          :click-handler="() => operationHandler('signUp')"
        ></Button>
        <Button
          classes="mb-5 btn-full btn-custom"
          type="button"
          :text="$t('Sign In')"
          :click-handler="() => operationHandler('signIn')"
        ></Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../components/UI/Button";
import SignUp from "../components/Login/SignUp";
import SignIn from "../components/Login/SignIn";
import Close from "../components/UI/Close.vue";

export default {
  name: "Login",
  components: {
    Button,
    SignUp,
    SignIn,
    Close
  },
  data() {
    return {
      token: null,
    };
  },
  computed: {
    loginParent() {
      return {
        "has-bg": !this.$getState("loginOperation"),
        "cause-single-view": this.$store.state.typeAppFilter === "causeSingle",
        "finished-bg": this.$store.state.loginActiveStep === "finished"
      };
    },
    logo() {
      return (
        !this.$getState("step_header") &&
        !this.$getState("corporation")["is"] &&
        this.$getState("loginActiveStep") != "phone" &&
        this.$getState("loginActiveStep") != "verification"
      );
    },
    corporationLogo() {
      return (
        this.$getState("corporation")["is"] &&
        this.$getState("corporation")["white_logo"] !== ""
      );
    },
    corporationSrcSet() {
      return `${this.$getState("corporation")["white_logo"]}, ${
        this.$getState("corporation")["white_logo"]
      }`;
    },
    signHeader() {
      return `${this.$store.state.appUrl}/img/pwa/login/signin-header.png`;
    },
    signHeader2x() {
      return `${this.$store.state.appUrl}/img/pwa/login/signin-header@2x.png`;
    },
    isHeaderImg() {
      const nopes = ["signUp", "signIn"];
      return (
        nopes.includes(this.$getState("loginOperation")) &&
        !this.$getState("forgotPasswordForm")
      );
    },
    signInIcon() {
      return `${this.$store.state.appUrl}/img/pwa/login/sign-icon.png`;
    },
    signInIcon2x() {
      return `${this.$store.state.appUrl}/img/pwa/login/sign-icon@2x.png`;
    },
    // loginLogo() {
    //   return `${this.$store.state.appUrl}/img/pwa/login/login-logo.png`;
    // },
    loginLogo2x() {
      return `${this.$store.state.appUrl}/img/pwa/login/login-logo@2x.png`;
    },
    loginLogoSrcSet() {
      return `${this.loginLogo2x}, ${this.loginLogo2x}`;
    }
  },
  beforeUpdate() {
    if (this.$getState("corporation")["is"]) {
      this.bgColor = this.$getState("corporation")["color_background"];
      this.btnColor = this.$getState("corporation")["button_color"];
      this.textColor = this.$getState("corporation")["color_input"];
      this.subTextColor = this.$getState("corporation")["sub_text_color"];
      this.linkColor = this.$getState("corporation")["link_color"];
      this.backBtnColor = this.$getState("corporation")["back_button_color"];
      this.iconColor = this.$getState("corporation")["icon_color"];
      this.savingTagColor = this.$getState("corporation")["saving_tag_color"];
    }
  },

  mounted() {
    if (localStorage.getItem("signup")) {
      localStorage.removeItem("signup");
      this.$setState("loginOperation", "signUp");
    }
    this.token = this.$route.query && this.$route.query.token;
    if (this.token) {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function() {
        window.history.pushState(null, "", window.location.href);
      };
    }
    this.checkLogin();
  },

  methods: {
    operationHandler: function(param) {
      if (param == "intro") {
        this.$setLocalStorage(
          "thriveAppReferral",
          this.$getLocalStorage("thriveAppReferral")
        );
        this.$router.push(
          `intro?referral=${this.$getLocalStorage("thriveAppReferral")}`
        );
      }

      this.$setLocalStorage("ThriveAppLoginProcessType", param);
      this.$setState("loginOperation", param);
    },
    checkLogin: function() {
      const loginProcessType = this.$getLocalStorage(
        "ThriveAppLoginProcessType"
      );
      this.$setLocalStorage("ThriveAppLoginProcessType", "");
      if (this.token) {
        this.$token.value = this.token;
        this.$http.defaults.headers["Authorization"] = "Bearer " + this.token;
        this.$http
          .post(
            "user/useronline",
            {},
            {
              headers: {
                Authorization: "Bearer " + this.token
              }
            }
          )
          .then(data => {
            const user = data.data.user;
            this.$store.commit("user", !user || !user.id ? false : user);
            this.$store.commit(
              "appUrl",
              !data.data.app_url ? "" : data.data.app_url
            );

            this.$store.commit(
              "fbAppID",
              !data.data.config.fb_app_id ? "" : data.data.config.fb_app_id
            );
            this.$store.commit(
              "stripeKey",
              !data.data.config.stripe_key ? "" : data.data.config.stripe_key
            );

            if (loginProcessType === "signIn") {
              if (this.$checkUser(user, this.token)) {
                this.$router.push("/dashboard");
              } else {
                if (this.$route.path !== "/login") {
                  this.router.push("/login");
                }
              }
            } else {
              this.$setState("loginOperation", "signUp");
              if (user && user.id !== undefined) {
                if (this.$checkUser(user, this.token)) {
                  this.$router.push("/dashboard");
                }
              }
            }
          });
      } else {
        let referral = this.$route.query.referral || "";
        let thriveAppReferral =
          this.$getLocalStorage("thriveAppReferral") || "";

        if (thriveAppReferral === "" && referral != "") {
          // this.$http.post("user/useronline", { referral: referral })
          this.$http.post("user/useronline").then(data => {
            if (
              data.data.is_corporation !== undefined &&
              data.data.is_corporation
            ) {
              this.$store.commit("referral", referral);
              if (data.data.corporation !== undefined) {
                const corp = data.data.corporation;
                corp.is = true;
                this.$store.commit("corporation", corp);
              }
            }
          });
        }
      }
    },
    backToLoginPage: function() {
      switch (this.$store.state.loginActiveStep) {
        case "cause": {
          return false;
        }
        case "bank": {
          this.$store.commit("loginShowOperationTitle", false);
          this.$store.commit("loginActiveStep", "cause");
          this.$store.commit("loginSteps", {
            card: false,
            cause: false,
            finished: false,
            signUp: true,
            donation: false
          });
          break;
        }
        case "card": {
          this.$store.commit("loginShowOperationTitle", true);
          this.$store.commit("loginActiveStep", "card");
          break;
        }
        case "addCard": {
          this.$store.commit("loginShowOperationTitle", true);
          this.$store.commit("loginActiveStep", "provide");
          break;
        }
        case "provide": {
          this.$store.commit("loginShowOperationTitle", true);
          this.$store.commit("loginActiveStep", "card");
          break;
        }
        case "donation": {
          this.$store.commit("loginShowOperationTitle", false);
          this.$store.commit("loginActiveStep", "donation");
          this.$store.commit("loginSteps", {
            card: true,
            cause: true,
            donation: false,
            finished: false,
            signUp: true
          });
          break;
        }
        default: {
          this.$setState("loginOperation", null);
          this.$setState("loginSteps", {
            card: false,
            cause: false,
            finished: false,
            signUp: false,
            donation: false
          });
          if (localStorage.getItem("signupSlider")) {
            this.$setState("showSignUpSlider", false);
          }
        }
      }
    }
  }
};
</script>

<style>
.btn-custom .btn,
.congratulations-btn {
  background-color: var(--btn-color);
  border: 1px solid var(--btn-color);
}

.title-black {
  color: var(--sub-text-color) !important;
}

.sign-up-or:before {
  background-color: var(--bg-color) !important;
}

.steps:before {
  border-top: 1px dashed var(--bg-color);
}

.card-component .cause-choice,
.choise-your-cause .cause-choice {
  border-bottom: 1px solid var(--bg-color);
}

.qr-bg-color {
  height: 500px;
  background-color: var(--bg-color);
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}
</style>
